<ng-container *ngIf="action$ | async as action">
  <p-button
    [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
    [ngClass]="action.name + ' hide-label-responsive'"
    label="Izvoz"
    ntapDebounceClick
    (click)="downloadAgentXml()"
    [disabled]="(enabled$ | async) === false"
    [pTooltip]="action.tooltip || action.description"
    tooltipPosition="left"
  ></p-button>
</ng-container>